// Encore Garage Door Systems — separate admin deployment, same neutral UI.
const encore = {
  key: "encore",
  name: "Encore GDS",
  legalName: "Encore Garage Door Systems Inc.",
  title: "Encore GDS | Admin",
  assets: {
    logo: "/assets/img/encore-logo-gold.svg",
    logoOnDark: "/assets/img/encore-logo-gold.svg",
    favicon: "/assets/img/encore-fav.svg",
    manifest: "/manifest.encore.json",
    // Auth pages are black for Encore (see auth below), so the gold logo needs no backing.
    authLogoClass: "!w-[170px] mt-3 mr-3",
  },
  // Quote-summary extras this brand's API offers (mirrors the API brand file).
  features: {
    // Installation charges per door / per operator, posted to BC inside the group.
    installationLines: true,
    // Default installation rates per customer (Customers > the customer), filled
    // in on that customer's quotes when they are saved.
    installationDefaults: true,
    // Second PDF format: the customer quote with door previews.
    customerPdf: true,
    // No feedback-survey banner on Encore's customer portal (Upwardor only for now).
    customerSurvey: false,
  },
  // Login / forgot / reset pages: no photo — black and gold backdrop drawn in
  // CSS (src/brand/encore-auth.scss), Encore tagline, gold accents.
  auth: {
    backdropClass: "encore-auth-backdrop",
    stripClass: "encore-auth-strip py-7 pl-5 lg:py-9 lg:pl-12",
    tagline: "encore",
    accentBg: "bg-[#CAA131]",
    linkText: "text-[#8C6D1F]",
    iconBox: "bg-[#CAA1311A] text-[#8C6D1F]",
    buttonText: "text-[#1A1A1A]",
    accentColor: "#CAA131",
  },
};

export default encore;
